import React from "react";
import styled from "@emotion/styled";
import { sidebarValueConstants } from "../sidebarutils";

import {
  SidebarDeleteIcon,
  SidebarDraftIcon,
  SidebarPublishIcon,
  SidebarSubmissionIcon,
} from "../../../components/Custom/Buttons/ButtonIcons";

interface SidebarIconRendererProps {
  iconkey: string;
  isSelected: boolean;
  isCollapsed?: boolean;
}

const SidebarIconWrapper = styled("div")<{ isCollapsed?: boolean }>`
  margin-right: ${(props) => (props.isCollapsed ? "0px" : "10px")};
  display: flex;
  align-items: center;
`;

function SidebarIconRenderer({
  iconkey,
  isSelected,
  isCollapsed,
}: SidebarIconRendererProps) {
  const getIconBasedOnIconKey = React.useMemo(() => {
    if (iconkey === sidebarValueConstants.deleted) {
      return <SidebarDeleteIcon isSelected={isSelected} />;
    } else if (iconkey === sidebarValueConstants.drafted) {
      return <SidebarDraftIcon isSelected={isSelected} />;
    } else if (iconkey === sidebarValueConstants.published) {
      return <SidebarPublishIcon isSelected={isSelected} />;
    } else if (iconkey === sidebarValueConstants.submissions) {
      return <SidebarSubmissionIcon isSelected={isSelected} />;
    } else {
      return <React.Fragment />;
    }
  }, [iconkey, isSelected]);

  return <SidebarIconWrapper isCollapsed={isCollapsed}>{getIconBasedOnIconKey}</SidebarIconWrapper>;
}

export default SidebarIconRenderer;
